import React, { useState } from "react";

const tiresData = [
  { name: "Michelin Defender T+H", price: 145, size: "205/55R16", brand: "Michelin" },
  { name: "Goodyear Assurance", price: 130, size: "215/60R16", brand: "Goodyear" },
  { name: "Bridgestone Turanza", price: 160, size: "225/45R17", brand: "Bridgestone" },
  { name: "Pirelli P4", price: 120, size: "205/65R16", brand: "Pirelli" },
  { name: "Continental TrueContact", price: 155, size: "215/55R17", brand: "Continental" },
  { name: "Hankook Kinergy", price: 110, size: "195/65R15", brand: "Hankook" },
];

export default function TireGlobe() {
  const [search, setSearch] = useState("");
  const [brand, setBrand] = useState("All");

  const filtered = tiresData.filter((tire) => {
    return (
      tire.size.toLowerCase().includes(search.toLowerCase()) &&
      (brand === "All" || tire.brand === brand)
    );
  });

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      {/* Header */}
      <header className="bg-black text-white p-6 flex justify-between items-center">
        <h1 className="text-2xl font-bold">Tire Globe</h1>
        <a href="tel:18502200222" className="bg-white text-black px-4 py-2 rounded-xl font-semibold">Call Now</a>
      </header>

      {/* Hero */}
      <section className="bg-[url('https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2')] bg-cover bg-center text-white py-28 text-center">
        <h2 className="text-5xl font-bold mb-4">Find the Perfect Tires</h2>
        <p className="mb-6">Search by size, compare prices, then call us to install.</p>

        <div className="flex flex-col md:flex-row justify-center gap-4">
          <input
            type="text"
            placeholder="Enter tire size (e.g. 205/55R16)"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="px-4 py-3 rounded-xl text-black w-72"
          />

          <select
            value={brand}
            onChange={(e) => setBrand(e.target.value)}
            className="px-4 py-3 rounded-xl text-black"
          >
            <option>All</option>
            <option>Michelin</option>
            <option>Goodyear</option>
            <option>Bridgestone</option>
            <option>Pirelli</option>
            <option>Continental</option>
            <option>Hankook</option>
          </select>
        </div>
      </section>

      {/* Results */}
      <section className="p-10">
        <h2 className="text-3xl font-bold mb-6">Available Tires</h2>

        <div className="grid md:grid-cols-3 gap-6">
          {filtered.map((tire, i) => (
            <div key={i} className="bg-white p-6 rounded-2xl shadow hover:shadow-lg transition">
              <div className="h-40 bg-gray-200 rounded-xl mb-4" />
              <h3 className="text-xl font-semibold">{tire.name}</h3>
              <p className="text-gray-600">Size: {tire.size}</p>
              <p className="text-gray-600">Brand: {tire.brand}</p>
              <p className="text-lg font-bold mt-2">${tire.price}</p>
              <p className="text-sm text-gray-500 mt-2">Call to order</p>
            </div>
          ))}
        </div>
      </section>

      {/* Trust Section */}
      <section className="bg-white p-10 text-center">
        <h2 className="text-3xl font-bold mb-4">Why Choose Tire Globe?</h2>
        <p className="text-gray-700">⭐ 4.9 Google Reviews • Fast Service • Local Experts</p>
      </section>

      {/* Contact */}
      <section className="bg-black text-white p-10 text-center">
        <h2 className="text-3xl font-bold mb-4">Contact Us</h2>
        <p>📍 8319 Back Beach Rd, Panama City Beach, FL</p>
        <p>📞 (850) 220-0222</p>
        <p className="mt-4">Open Daily</p>
      </section>

      {/* Sticky Call Button */}
      <a
        href="tel:18502200222"
        className="fixed bottom-6 right-6 bg-black text-white px-6 py-4 rounded-full shadow-lg text-lg"
      >
        📞 Call Now
      </a>
    </div>
  );
}
